<script setup lang="ts">
import { computed } from 'vue'

import { QueueViewPopoverButton } from '@collector/desktop-feature-incidents-queue-ui'
import { buttonClass } from '@desktop/views/Relation/components/RelationView/Header/RelationButtons/consts'
import {
  useIncidents,
  useParticipants,
  useSportMaps,
} from '@desktop/views/Relation/composables'
import { useQueueClient } from '@desktop/views/Relation/composables/queue/useQueueClient'
import { injectEventIncidentsQueue } from '@desktop/views/Relation/provide-inject'
import { useBetIncidents } from '@desktop/views/Relation/Sports/composables'
import { useInitEventIncidentsQueue } from '@desktop/views/Relation/Sports/init'

// inject
const eventIncidentsQueue = injectEventIncidentsQueue()

// composables
const { isIncidentEmergencyOrBet } = useBetIncidents()
const { getIncident } = useIncidents()
const { homeParticipant, awayParticipant } = useParticipants()
const { incidentIdToSportIncidentMap } = useSportMaps()
const { initEventIncidentsQueue } = useInitEventIncidentsQueue()
const { connected } = useQueueClient()

const queueButtonClass = computed(() =>
  [
    buttonClass,
    '[&>svg]:drop-shadow-sm',
    connected.value
      ? '[&>svg]:text-success-3 [&>svg]:drop-shadow-success-9'
      : '[&>svg]:text-error-5 [&>svg]:drop-shadow-error-9',
  ].join(' '),
)

// init
initEventIncidentsQueue()
</script>

<template>
  <QueueViewPopoverButton
    v-if="homeParticipant && awayParticipant"
    :class="queueButtonClass"
    :eventIncidentsQueue
    :isIncidentImportant="isIncidentEmergencyOrBet"
    :getIncident
    :homeParticipant
    :awayParticipant
    :incidentIdToSportIncidentMap
    icon="wifi"
    size="sm"
    iconSize="sm"
  >
    <span class="@max-sm:hidden">Queue</span>
  </QueueViewPopoverButton>
</template>
